/* eslint-disable react/jsx-props-no-spreading */
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Autocomplete,
  TextField,
  CircularProgress,
} from "@mui/material";
import type { AvailableApiItem } from "../types/api-types";

interface TemplateApiFormDialogProps {
  open: boolean;
  availableApis: AvailableApiItem[];
  selectedEndpoint: string;
  isSaving: boolean;
  isLoadingApis: boolean;
  onClose: () => void;
  onSave: () => void;
  onEndpointChange: (endpoint: string, apiId: number) => void;
}

const TemplateApiFormDialog = ({
  open,
  availableApis,
  selectedEndpoint,
  isSaving,
  isLoadingApis,
  onClose,
  onSave,
  onEndpointChange,
}: TemplateApiFormDialogProps) => {
  const isFormValid = selectedEndpoint.trim();

  const handleAutocompleteChange = (
    _e: unknown,
    newValue: AvailableApiItem | null,
  ) => {
    if (newValue) {
      onEndpointChange(newValue.endPoint, newValue.id);
    } else {
      onEndpointChange("", 0);
    }
  };

  const selectedApi = availableApis.find(
    (api) => api.endPoint === selectedEndpoint,
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Add API</DialogTitle>
      <DialogContent>
        {isLoadingApis ? (
          <CircularProgress />
        ) : (
          <Autocomplete
            options={availableApis}
            getOptionLabel={(option) => option.endPoint}
            value={selectedApi || null}
            onChange={handleAutocompleteChange}
            renderInput={(params) => (
              <TextField
                {...params}
                margin="dense"
                label="Endpoint"
                placeholder="Select API Endpoint"
                helperText="Select from available API endpoints"
                autoFocus
                onKeyDown={(e) => {
                  if (e.key === "Enter" && isFormValid) {
                    onSave();
                  }
                }}
              />
            )}
            fullWidth
            disabled={isSaving}
            sx={{ mt: 1 }}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit" disabled={isSaving}>
          Cancel
        </Button>
        <Button
          onClick={onSave}
          variant="contained"
          disabled={!isFormValid || isSaving}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TemplateApiFormDialog;
